import { useEffect, useState } from 'react';

import * as helpers from '../helpers';

export const GEOCOMPLY_MAX_RETRY_TIMES = 5;

export const useScheduler = ({
    sdk,
    nextTime,
    license,
    transactionID,
    userId,
    identifierType,
    setTransactionID,
    setLicense,
    setNextTime,
    triggerGeolocation,
    requestPacket
}) => {
    const [retry, setRetry] = useState(0);

    useEffect(() => {
        if (!sdk || !license || !transactionID || !userId) {
            return;
        }

        const timeout = setTimeout(() => {
            const handlerUUID = helpers.retrieveHandlerUUID();
            const transactionHandlerUUID = helpers.retrieveTransactionHandlerUUID(transactionID);

            if (!transactionHandlerUUID) {
                setRetry(0);

                // we are the first to do it
                helpers.setTransactionHandlerUUID(transactionID);

                requestPacket();
            } else if (transactionHandlerUUID === handlerUUID) {
                setRetry(0);

                // there was an error, most likely, and we retry
                requestPacket();
            } else {
                if (retry > GEOCOMPLY_MAX_RETRY_TIMES) {
                    setRetry(0);

                    // cleanup the block and retry as if no one else is trying
                    helpers.unsetTransactionHandlerUUID(transactionID);
                } else {
                    setRetry(retry + 1);
                }

                // unset current timeout
                setTransactionID(null);
                setLicense(null);
                setNextTime(0);
            }
        }, nextTime);

        return () => {
            clearTimeout(timeout);
        };
    }, [
        sdk,
        retry,
        nextTime,
        license,
        transactionID,
        userId,
        identifierType,
        triggerGeolocation,
        setTransactionID,
        setLicense,
        setNextTime,
        requestPacket
    ]);

    useEffect(() => {
        if (!sdk || !userId || retry <= 0 || license || transactionID) {
            return;
        }

        const timeout = setTimeout(() => {
            triggerGeolocation();
        }, 3000 * retry);

        return () => {
            clearTimeout(timeout);
        };
    }, [
        sdk,
        triggerGeolocation,
        license,
        userId,
        transactionID,
        retry
    ]);
};
